import { FEATURE_FLAGS } from './feature-flags';
import { PermissionRequirement } from '../auth/authorization.types';
export type NavigationIcon = 'dashboard' | 'products' | 'inventory' | 'movements' | 'reports' | 'settings' | 'development' | 'logout';

export type NavigationItem = {
  key: 'dashboard' | 'products' | 'inventory' | 'movements' | 'reports' | 'settings' | 'development' | 'logout';
  labelKey: string;
  icon: NavigationIcon;
  route?: string;
  permission?: PermissionRequirement;
};

export const NAVIGATION_ITEMS: readonly NavigationItem[] = [
  { key: 'dashboard', labelKey: 'sidebar.dashboard', icon: 'dashboard', route: '/dashboard', permission: { key: 'dashboard', level: 'read' } },
  { key: 'products', labelKey: 'sidebar.products', icon: 'products', route: '/products', permission: { key: 'products', level: 'read' } },
  { key: 'inventory', labelKey: 'sidebar.inventory', icon: 'inventory', route: '/inventory', permission: { key: 'inventory', level: 'read' } },
  { key: 'movements', labelKey: 'sidebar.movements', icon: 'movements', route: '/movements', permission: { key: 'movements', level: 'read' } },
  { key: 'reports', labelKey: 'sidebar.reports', icon: 'reports', route: '/reports', permission: { key: 'reports', level: 'read' } },
  { key: 'settings', labelKey: 'sidebar.settings', icon: 'settings', route: '/settings', permission: { key: 'settings', level: 'read' } },
  ...(FEATURE_FLAGS.showDevelopmentTools
    ? [{ key: 'development', labelKey: 'sidebar.development', icon: 'development', route: '/development' } satisfies NavigationItem]
    : []),
  { key: 'logout', labelKey: 'sidebar.logout', icon: 'logout' },
] as const;
